<template>
    <div class="main">
        <el-dialog
            :title="openData.title"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="700px"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    :disabled="openData.title == '详情'"
                    label-position="left"
                    label-width="130px"
                    ref="formData"
                    :model="formData"
                    :rules="formDataRules"
                >
                    <el-form-item label="上级类别名称：" prop="parentId">
                        <el-select
                            :disabled="bigList.length == 0"
                            @change="parentChange"
                            v-model="formData.parentId"
                            placeholder="请选择名称"
                            style="width: 100%"
                        >
                            <!-- orgList -->
                            <el-option
                                v-for="item in bigList"
                                :key="item.id"
                                :label="item.businessName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="业务类别名称：" prop="businessName">
                        <el-input
                            v-model.trim="formData.businessName"
                            placeholder="请输入名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="业务类别级：" prop="type">
                        <el-select
                            disabled
                            v-model="formData.type"
                            placeholder="请选择级别"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in selectData"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="录入时间：" prop="inputDate">
                        <el-date-picker
                            v-model="formData.inputDate"
                            type="datetime"
                            style="width: 100%"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd"
                            placeholder="录入时间"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer dialog-footer-btn"
                v-if="openData.title != '详情'"
            >
                <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                >
                <el-button @click="dialogVisibleClone">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData"],

    data() {
        return {
            formData: {
                parentId: "",
                businessName: "",
                inputDate: "",
                type: "",
            },
            formDataRules: {
                parentId: [
                    {
                        required: false,
                        message: "上级类别名称不能为空",
                        trigger: "blur",
                    },
                ],
                businessName: [
                    {
                        required: true,
                        message: "业务类别名称不能为空",
                        trigger: "blur",
                    },
                ],
                inputDate: [
                    {
                        required: true,
                        message: "创建时间不能为空",
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "录入时间不能为空",
                        trigger: "blur",
                    },
                ],
            },
            bigList: [],
            selectData: [
                { value: "1", label: "一级" },
                { value: "2", label: "二级" },
            ],
        }
    },
    created() {
        this.getVersion()
    },
    methods: {
        // 切换级别
        parentChange() {
            this.formData.type = "2"
        },
        // 获取分类
        getVersion() {
            let params = {
                pageNo: 1,
                pageSize: 1000,
                type: 1,
            }
            this.$http
                .request({
                    url: "/ypt/admin/businessDatabaseCategory/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.bigList = []
                            return
                        }
                        this.bigList = res.content.list

                        if (this.openData.title != "新增") {
                            this.getData()
                        } else {
                            this.formData = {
                                parentId: "",
                                businessName: "",
                                inputDate: "",
                                type: "",
                            }
                            if (this.bigList.length == 0) {
                                this.bigList = [{ id: 0, businessName: "" }]
                                this.formData.type = "1"
                                this.formData.parentId = 0
                            }
                        }
                    }
                })
        },
        getData() {
            const self = this
            let params = {
                id: self.openData.id,
            }
            this.$http
                .request({
                    url: "/ypt/admin/businessDatabaseCategory/info/get",
                    method: "POST",
                    data: params,
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        let jsonTemp = { ...res.content }
                        self.formData.id = jsonTemp.id
                        self.formData.parentId = jsonTemp.parentId
                        self.formData.businessName = jsonTemp.businessName
                        self.formData.inputDate = jsonTemp.inputDate
                        self.formData.type = jsonTemp.type
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        handleSubmit() {
            let self = this

            this.$refs.formData.validate((valid) => {
                if (valid) {
                    if (
                        this.openData.title == "新增" ||
                        this.openData.title == "编辑"
                    ) {
                        let url = ""
                        let data = { ...self.formData }
                        url = "/ypt/admin/businessDatabaseCategory/info/save"
                        this.$http
                            .request({
                                url: url,
                                method: "POST",
                                data: {
                                    ...data,
                                },
                            })
                            .then((res) => {
                                if (res.code == 200) {
                                    this.$emit("cancleAddress", true)
                                    this.$message.success(res.message)
                                } else {
                                    this.$message.error(res.message)
                                }
                            })
                    }
                }
            })
        },
        dialogVisibleClone() {
            this.$emit("cancleAddress", false)
        },
    },
}
</script>
<style lang="less" scoped>
</style>